import { render, staticRenderFns } from "./SocialCampaignDetails.vue?vue&type=template&id=d7f1e35c&scoped=true"
import script from "./SocialCampaignDetails.vue?vue&type=script&lang=js"
export * from "./SocialCampaignDetails.vue?vue&type=script&lang=js"
import style0 from "./SocialCampaignDetails.vue?vue&type=style&index=0&id=d7f1e35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f1e35c",
  null
  
)

export default component.exports